import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { StatusSelector } from "./StatusSelector";
import { ContractStatus } from "@/types";

interface MembershipCardProps {
  membershipNumber: string;
  agreementNumber: string;
  membershipLevel: string;
  termYears: number;
  pointsRightsPurchased: number;
  newPointsPurchased?: number;
  firstYearUse: number;
  pointsRightsDueDate?: number;
  status?: string;
  onStatusChange?: (newStatus: string) => void;
  isStatusEditingDisabled?: boolean;
  userRole?: string;
}

export function MembershipCard({
  membershipNumber,
  agreementNumber,
  membershipLevel,
  termYears,
  pointsRightsPurchased,
  newPointsPurchased,
  firstYearUse,
  pointsRightsDueDate,
  status,
  onStatusChange,
  isStatusEditingDisabled = false,
  userRole
}: MembershipCardProps) {
  // Highlight status for managers when contract is in New status
  const shouldHighlightStatus = userRole === 'manager' && status === ContractStatus.New;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Membership Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="grid grid-cols-2 gap-2">
          {status && onStatusChange && (
            <>
              <span className="font-medium">Status:</span>
              <div className={shouldHighlightStatus ? "p-2 border-2 border-blue-500 rounded-md bg-blue-50" : ""}>
                <StatusSelector
                  currentStatus={status}
                  onChange={onStatusChange}
                  disabled={isStatusEditingDisabled}
                />
              </div>
            </>
          )}
          <span className="font-medium">Owner ID:</span>
          <span>{membershipNumber}</span>
          <span className="font-medium">Agreement Number:</span>
          <span>{agreementNumber}</span>
          <span className="font-medium">Membership Level:</span>
          <span>{membershipLevel}</span>
          <span className="font-medium">Term Years:</span>
          <span>{termYears}</span>
          <span className="font-medium">Points Rights Purchased (Total):</span>
          <span>{pointsRightsPurchased}</span>
          <span className="font-medium">New Points Purchased:</span>
          <span>{newPointsPurchased || 0}</span>
          <span className="font-medium">First Year Use:</span>
          <span>{firstYearUse}</span>
          <span className="font-medium">Points Rights Due Date:</span>
          <span>{pointsRightsDueDate}</span>
        </div>
      </CardContent>
    </Card>
  );
}